import { SVGFC } from '@repo/toolkit/types'

const WarningIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15088_57583)">
        <path
          d="M13.3441 12.2296L11.2113 8.53544C10.9942 8.15864 10.9355 7.71104 11.0483 7.29103C11.161 6.87101 11.4359 6.51293 11.8125 6.29549C12.1891 6.07805 12.6367 6.01903 13.0568 6.13141C13.4769 6.24379 13.8352 6.51837 14.053 6.89481L17.3342 12.5781"
          stroke={color}
          strokeWidth="0.984375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8299 14.4386L7.71268 9.03952C7.60474 8.85292 7.53463 8.64689 7.50636 8.43318C7.47809 8.21948 7.49221 8.0023 7.54791 7.79406C7.60362 7.58581 7.69982 7.39059 7.83101 7.21954C7.9622 7.04849 8.12581 6.90498 8.3125 6.79719C8.49918 6.68941 8.70528 6.61948 8.91901 6.59138C9.13274 6.56329 9.3499 6.57759 9.5581 6.63347C9.7663 6.68935 9.96144 6.78571 10.1324 6.91705C10.3033 7.04838 10.4467 7.21212 10.5543 7.39889L13.3434 12.2297"
          stroke={color}
          strokeWidth="0.984375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1309 17.0605C15.6958 16.3068 15.5779 15.4112 15.8031 14.5706C16.0284 13.73 16.5783 13.0134 17.332 12.5782L16.5116 11.1574C16.4037 10.9708 16.3336 10.7648 16.3053 10.5511C16.277 10.3374 16.2912 10.1202 16.3469 9.91194C16.4026 9.7037 16.4988 9.50848 16.63 9.33743C16.7612 9.16638 16.9248 9.02287 17.1115 8.91508C17.2981 8.8073 17.5042 8.73736 17.718 8.70927C17.9317 8.68118 18.1489 8.69548 18.3571 8.75136C18.5653 8.80724 18.7604 8.9036 18.9313 9.03494C19.1023 9.16627 19.2457 9.33001 19.3533 9.51678L20.9939 12.3584C21.425 13.1048 21.7049 13.9287 21.8176 14.7833C21.9302 15.6378 21.8734 16.5062 21.6504 17.3387C21.4274 18.1713 21.0426 18.9518 20.518 19.6357C19.9933 20.3195 19.339 20.8933 18.5926 21.3242C17.8462 21.7552 17.0221 22.0349 16.1676 22.1473C15.313 22.2598 14.4447 22.2028 13.6121 21.9796C12.7796 21.7565 11.9992 21.3715 11.3155 20.8467C10.6318 20.3218 10.0581 19.6675 9.62732 18.9209L6.51014 13.5218C6.29301 13.145 6.23437 12.6974 6.3471 12.2774C6.45983 11.8574 6.73471 11.4993 7.11133 11.2819C7.48795 11.0644 7.93549 11.0054 8.35561 11.1178C8.77572 11.2302 9.13402 11.5047 9.35178 11.8812L10.8283 14.4387M10.1509 23.1877C9.03861 22.416 8.11141 21.407 7.43617 20.2336M17.9362 6.04297C18.6849 6.04287 19.4205 6.23997 20.0689 6.61444C20.7173 6.98891 21.2556 7.52754 21.6297 8.17614"
          stroke={color}
          strokeWidth="0.984375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15088_57583">
          <rect width="21" height="21" fill="white" transform="translate(3.5 3.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WarningIcon
